import {
  coercePermissionBool,
  normalizePermissionList,
  type Permission,
} from "./permissions";

export function mergePermissionsByFeatureName(
  basePerms: unknown[],
  facilityPerms: unknown[],
): Permission[] {
  const byName = new Map<string, Permission>();

  normalizePermissionList(basePerms).forEach((p) => {
    if (p.feature_name) byName.set(p.feature_name.toLowerCase(), p);
  });
  normalizePermissionList(facilityPerms).forEach((p) => {
    if (p.feature_name) byName.set(p.feature_name.toLowerCase(), p);
  });

  return Array.from(byName.values());
}

export function canViewFacilityFeature(
  featureName: string,
  permissions: Permission[],
  fallbackCanView: boolean,
  isGlobalAdmin: boolean,
): boolean {
  if (isGlobalAdmin) return true;
  if (permissions.length === 0) return fallbackCanView;

  const permission = permissions.find(
    (p) => p.feature_name?.toLowerCase() === featureName.toLowerCase(),
  );
  return permission ? coercePermissionBool(permission.view) : false;
}
